import bilateralMeetingsOts2025 from '../../src/assets/news-from-us/bilateral-meetings-ots-2025.jpeg';

export const newsFromUsData = [
  {
    id: 'ots-tourism-meeting-2025',
    date: '2025-07-08',
    category: 'Summit',
    image: 'https://www.turkicstates.org/u/i/n/2025/img_6851jpeg.jpg',
    featured: true,
    translations: {
      en: {
        title: "OTS Delegation Participates in Tourism Working Group Meeting",
        excerpt: "On 8 July 2025, a delegation led by the Deputy Secretary General of the Organization of Turkic States (OTS), Dr. Mirvokhid Azimov, participated in the 20th Meeting of the Working Group on Tourism, convened in Ankara ahead of the 10th Meeting of the Ministers in Charge of Tourism.",
        content: `On 8 July 2025, a delegation led by the Deputy Secretary General of the Organization of Turkic States (OTS), Dr. Mirvokhid Azimov, participated in the 20th Meeting of the Working Group on Tourism, convened in Ankara ahead of the 10th Meeting of the Ministers in Charge of Tourism.`
      },
      tr: {
        title: "TDT Heyeti Turizm Çalışma Grubu Toplantısına Katıldı",
        excerpt: "Türk Devletleri Teşkilatı (TDT) Genel Sekreter Yardımcısı Dr. Mirvokhid Azimov başkanlığındaki heyet, Turizmden Sorumlu Bakanlar 10. Toplantısı öncesinde 8 Temmuz 2025 tarihinde Ankara’da düzenlenen Turizm Çalışma Grubu 20. Toplantısına katıldı.",
        content: `Türk Devletleri Teşkilatı (TDT) Genel Sekreter Yardımcısı Dr. Mirvokhid Azimov başkanlığındaki heyet, Turizmden Sorumlu Bakanlar 10. Toplantısı öncesinde 8 Temmuz 2025 tarihinde Ankara’da düzenlenen Turizm Çalışma Grubu 20. Toplantısına katıldı.`
      }
    }
  },
  {
    id: 'bilateral-meetings-ots-2025',
    date: '2025-07-09',
    category: 'Diplomacy',
    // Note: Replace this string with require('../../assets/your-image.jpg') when you create the file
    image: bilateralMeetingsOts2025,
    featured: true,
    translations: {
      en: {
        title: "Bilateral Meetings Held at Organization of Turkic States",
        excerpt: "Bilateral meetings were held in the Organization of Turkic States.",
        content: "Bilateral meetings were held in the Organization of Turkic States."
      },
      tr: {
        title: "Türk Devletleri Teşkilatında İkili Görüşmeler Gerçekleştirildi",
        excerpt: "Türk devletler teşkilatında ikili görüşmeler gerçekleştirilmiştir",
        content: "Türk devletler teşkilatında ikili görüşmeler gerçekleştirilmiştir"
      }
    }
  }
];
